import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PlateDisplay from "../PlateDisplay";

const RecentPlateLink = ({
  plate,
  createdAt,
  plateStyle = "malaysia-legacy",
}) => {
  const { t } = useTranslation();

  const getRelativeTime = (date) => {
    const now = new Date();
    const then = new Date(date);
    const diffInSeconds = Math.floor((now - then) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds}s`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes}m`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours}h`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return `${diffInDays}d`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths}mo`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears}y`;
  };

  return (
    <Link
      to={`/plate/${plate}`}
      className="block rounded transition-all p-2 text-center group"
    >
      <div className="flex flex-col items-center justify-between h-full">
        <PlateDisplay
          plate={plate}
          plateStyle={plateStyle}
          size="large"
          className="transform group-hover:shadow-lg scale-90 md:scale-100 transition-transform duration-300 group-hover:rotate-3"
        />
        <span className="text-gray-400 text-xs dark:text-gray-400">
          {getRelativeTime(createdAt)}
        </span>
      </div>
    </Link>
  );
};

export default React.memo(RecentPlateLink);
